module.exports = __webpack_public_path__ + "static/media/siirler.eae50e41.png";